/* EdgePro hero: cross-fade the background through its slides.

   Deliberately quiet about it — no dots, no arrows. The background is
   atmosphere behind the copy, not a control the visitor operates.

   Pauses when the hero scrolls out of view or the tab is hidden, so it is not
   burning paint work nobody can see. Honours prefers-reduced-motion by simply
   never starting, which leaves the first image showing. */
(function () {
  if (window.__epHeroRotate) return;
  window.__epHeroRotate = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(media) {
    var slides = media.querySelectorAll('.ep-hero__image');
    if (slides.length < 2) return;

    var seconds = parseFloat(media.getAttribute('data-ep-hero-rotate')) || 6;
    var delay = Math.max(3, seconds) * 1000;
    var index = 0;
    var timer = null;
    var visible = true;

    function show(next) {
      slides[index].classList.remove('is-active');
      index = next;
      slides[index].classList.add('is-active');
    }

    function tick() {
      show((index + 1) % slides.length);
    }

    function start() {
      if (timer || reduced || !visible || document.hidden) return;
      timer = setInterval(tick, delay);
    }

    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) start();
          else stop();
        },
        { threshold: 0.01 }
      ).observe(media);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  document.querySelectorAll('[data-ep-hero-rotate]').forEach(init);
})();
